// Shared options and helpers for the Profit/Loss module.

export const DATE_MODES = [
  { label: "All time", value: "ALL" },
  { label: "Year", value: "YEAR" },
  { label: "Month", value: "MONTH" },
  { label: "Custom range", value: "CUSTOM" },
];

export const MODULE_OPTIONS = [
  { label: "All modules", value: "" },
  { label: "Admission", value: "Admission" },
  { label: "RPL", value: "RPL" },
  { label: "Visa", value: "Visa" },
  { label: "Insurance", value: "Insurance" },
  { label: "Skill Assessment", value: "Skill Assessment" },
  { label: "Student", value: "Student" },
];

export const CLAIM_OPTIONS = [
  { label: "All", value: "ALL" },
  { label: "Commission claimed", value: "COMMISSION_CLAIMED" },
  { label: "Commission pending", value: "COMMISSION_PENDING" },
  { label: "Bonus claimed", value: "BONUS_CLAIMED" },
  { label: "Bonus pending", value: "BONUS_PENDING" },
];

export const MONTHS = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const yearsForFilter = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

export const num = (value) => Number(value) || 0;

const pad2 = (n) => String(n).padStart(2, "0");
const iso = (y, m, d) => `${y}-${pad2(m)}-${pad2(d)}`;
const lastDayOfMonth = (y, m) => new Date(y, m, 0).getDate();

// Resolve the date-mode selection into the from/to range the backend expects.
export const deriveDateRange = ({ dateMode, year, month, from, to }) => {
  switch (dateMode) {
    case "YEAR":
      return { from: iso(year, 1, 1), to: iso(year, 12, 31) };
    case "MONTH":
      return { from: iso(year, month, 1), to: iso(year, month, lastDayOfMonth(year, month)) };
    case "CUSTOM":
      return { from: from || undefined, to: to || undefined };
    case "ALL":
    default:
      return { from: undefined, to: undefined };
  }
};

export const formatMoney = (value) =>
  `$ ${num(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export { formatDisplayDate as formatDate } from "utils/dateFormat";

// Green for non-negative, red for negative — used on profit/loss figures.
export const plColor = (value) => (num(value) >= 0 ? "success.main" : "error.main");
